'use client';

import { getCookie } from '@fe-common-utils/libs/cookie';
import { FONT_SIZE_COOKIE } from '@fe-news/components/AnueTopBar/type';
import { create } from 'zustand';

type FontSizeThemeType = 'default' | 'large';

interface FontSizeState {
  fontSize: FontSizeThemeType;
  setFontSize: (size?: FontSizeThemeType) => void;
  initializeFontSize: () => void;
}

// 字體大小 html root 元素的 dataset
export const useFontSizeStore = create<FontSizeState>(set => ({
  fontSize: 'default',

  setFontSize: (size = 'default') => {
    set({ fontSize: size });

    // 更新 HTML root 元素的 dataset
    if (typeof document !== 'undefined') {
      document.documentElement.dataset.fontSize = size;
    }
  },

  initializeFontSize: () => {
    const savedFontSize = getCookie(FONT_SIZE_COOKIE) as string | undefined;

    const initialSize = savedFontSize ? 'large' : 'default';

    set({ fontSize: initialSize });

    // 更新 HTML root 元素的 dataset
    if (typeof document !== 'undefined') {
      document.documentElement.dataset.fontSize = initialSize;
    }
  }
}));
